import { FC } from "react";
import { useTranslation } from "react-i18next";

import { STATION_TIMING_NO_DATA_GROUP_ID } from "./station-timing-preview.constants";

interface IStationTimingNoDataToggleProps {
  legsCount: number;
  isExpanded: boolean;
  onToggle: () => void;
}

export const StationTimingNoDataToggle: FC<IStationTimingNoDataToggleProps> = ({
  legsCount,
  isExpanded,
  onToggle,
}) => {
  const { t } = useTranslation();
  const label = isExpanded
    ? t("stationTiming.HIDE_LEGS_WITHOUT_DATA", { legsCount })
    : t("stationTiming.SHOW_LEGS_WITHOUT_DATA", { legsCount });

  return (
    <button
      type="button"
      className="station-timing__expander"
      aria-expanded={isExpanded}
      aria-controls={STATION_TIMING_NO_DATA_GROUP_ID}
      onClick={onToggle}
    >
      {/* The caret only repeats what aria-expanded already says, so it stays out of the a11y tree. */}
      <span className="station-timing__expander-caret" aria-hidden="true">
        {isExpanded ? "▾" : "▸"}
      </span>
      {label}
    </button>
  );
};
